class SwiperComponent extends HTMLElement {
    constructor() {
        super();
        this.swipers = this.querySelectorAll('swiper-container');
        this.thumbs = this.querySelectorAll('.swiper-delimiter .swiper-thumbs');
        this.swiperInstances = [];
    }

    connectedCallback() {
        this.swipers.forEach(swiper => {
            this._initSwiper(swiper);
        });

        this.thumbs.forEach(swiper => {
            this._initThumbs(swiper);
        });

        $(document).on('quick-buy-popover:change:end', e => {
            this.swipers.forEach(swiper => {
                this._initSwiper(swiper);
            });
        });

        window.addEventListener('resize', () => {
            this._handleResize();
        });
    }

    _initSwiper(swiper) {
        const isMobileOnly = swiper.classList.contains('mobile-only');
        const swiperEl = this.querySelector("swiper-container");
        const sectionId = swiperEl.dataset.sectionId;

        if (window.innerWidth <= 999 && isMobileOnly) {
            if (!swiper.swiperInstance) {
                swiper.swiperInstance = new Swiper(swiper, {
                    slidesPerView: swiper.getAttribute('slides-per-view') || 1,
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    thumbs: {
                        swiper: '#thumbs-' + sectionId
                    },
                    scrollbar: {
                        el: '#scrollbar-' + sectionId,
                        draggable: true,
                    }
                });
                this.swiperInstances.push(swiper.swiperInstance);
            } else {
                if (swiper.swiperInstance) {
                    swiper.swiperInstance.destroy();
                    swiper.swiperInstance = null;
                    this.swiperInstances = this.swiperInstances.filter(instance => instance !== swiper.swiperInstance);
                }
            }
        } else {
            swiper.swiperInstance = new Swiper(swiper, {
                slidesPerView: swiper.getAttribute('slides-per-view') || 1,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                thumbs: {
                    swiper: '#thumbs-' + sectionId
                },
                scrollbar: {
                    el: '#scrollbar-' + sectionId,
                    draggable: true,
                }
            });
            this.swiperInstances.push(swiper.swiperInstance);
        }
    }

    _initThumbs(swiper) {
        var slides = this.querySelectorAll('.swiper-delimiter .swiper-slide').length
        swiper.swiperInstance = new Swiper(swiper, {
            loop: false,
            followFinger: false,
            slidesPerView: slides,
            allowTouchMove: false,
            allowSlidePrev: false,
            allowSlideNext: false,
            spaceBetween: 4,
            swipeToSlide: false,
            centerInsufficientSlides: true,
            freeMode: false,
        })
    }

    _handleResize() {
        this.swipers.forEach(swiper => {
            this._initSwiper(swiper);
        });
    }
}

window.customElements.define('swiper-chrono', SwiperComponent);
